import { render, staticRenderFns } from "./importBlockList.vue?vue&type=template&id=b5838eb4&scoped=true&"
import script from "./importBlockList.vue?vue&type=script&lang=js&"
export * from "./importBlockList.vue?vue&type=script&lang=js&"
import style0 from "./importBlockList.vue?vue&type=style&index=0&id=b5838eb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5838eb4",
  null
  
)

export default component.exports